export default "__VITE_ASSET__5792b094__"